export const FIND_SPOTS_FAILURE = 'FIND_SPOTS_FAILURE';

export const findSpotsFailure = ( payload: Error ) => ({
    type: FIND_SPOTS_FAILURE,
    payload,
});